import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    allowText: true,
    allowVideo: true,
    messages: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const guestbookSlice = createSlice({
  name: 'guestbook',
  initialState,
  reducers: {
    guestbookStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        allowText: blockContent?.allowText ?? true,
        allowVideo: blockContent?.allowVideo ?? true,
        messages: blockContent?.messages ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    guestbookClear: () => initialState,

    guestbookUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    guestbookUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    guestbookUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  guestbookStore,
  guestbookClear,
  guestbookUpdateIsLoading,
  guestbookUpdateIsActive,
  guestbookUpdateBlockContent,
} = guestbookSlice.actions;

export const selectGuestbookIsLoading = (state) => state.guestbook.isLoading;
export const selectGuestbookId = (state) => state.guestbook.id;
export const selectGuestbookUID = (state) => state.guestbook.uid;
export const selectGuestbookSID = (state) => state.guestbook.sid;
export const selectGuestbookBlockContent = (state) => state.guestbook.blockContent;
export const selectGuestbookItemDesign = (state) => state.guestbook.itemDesign;
export const selectGuestbookContainerDesign = (state) => state.guestbook.containerDesign;

export default guestbookSlice.reducer;
